export type ImportMode = "single" | "multi";

export interface FieldDef {
  key: string;
  label: string;
}

const BASE_REQUIRED_FIELDS: FieldDef[] = [
  { key: "name", label: "Asset Name" },
  { key: "asset_type", label: "Asset Type" },
  { key: "status", label: "Status" },
];

export function getRequiredFields(importMode: ImportMode): FieldDef[] {
  if (importMode === "multi") {
    return [{ key: "property_id", label: "Property ID" }, ...BASE_REQUIRED_FIELDS];
  }
  return BASE_REQUIRED_FIELDS;
}

export const OPTIONAL_FIELDS: FieldDef[] = [
  { key: "manufacturer", label: "Manufacturer" },
  { key: "model", label: "Model" },
  { key: "serial_number", label: "Serial Number" },
  { key: "asset_code", label: "Asset Code" },
  { key: "condition", label: "Condition" },
  { key: "purchase_date", label: "Purchase Date" },
  { key: "purchase_price", label: "Purchase Price" },
  { key: "warranty_expires", label: "Warranty Expires" },
  { key: "last_maintenance", label: "Last Maintenance" },
  { key: "next_maintenance", label: "Next Maintenance" },
  { key: "manufacture_date", label: "Manufacture Date" },
  { key: "installation_date", label: "Installation Date" },
  { key: "commission_date", label: "Commission Date" },
  { key: "size_tons", label: "Size (Tons)" },
  { key: "system_type", label: "System Type" },
  { key: "gas_pack", label: "Gas Pack (TRUE/FALSE)" },
  { key: "mounting_type", label: "Mounting Type" },
  { key: "separate_air_handler", label: "Separate Air Handler (TRUE/FALSE)" },
  { key: "refrigerant_type", label: "Refrigerant Type" },
  { key: "health_score", label: "Health Score" },
  { key: "lifecycle_stage", label: "Lifecycle Stage" },
  { key: "remaining_useful_life_months", label: "Remaining Life (Months)" },
  { key: "total_cost_ownership", label: "Total Cost of Ownership" },
  { key: "mtbf_hours", label: "MTBF Hours" },
  { key: "mttr_hours", label: "MTTR Hours" },
  { key: "availability_percentage", label: "Availability %" },
  { key: "energy_consumption_12m", label: "Energy Consumption (12m)" },
  { key: "co2_emissions_12m", label: "CO2 Emissions (12m)" },
  { key: "notes", label: "Notes" },
];

export const ASSET_TYPES = [
  "HVAC", "Plumbing", "Electrical", "Lighting", "Security", "Fire Safety",
  "Elevator", "Generator", "Appliance", "Furniture", "IT Equipment", "Other",
];
export const STATUSES = ["Active", "Maintenance", "Out-of-Service", "Decommissioned"];
export const CONDITIONS = ["New", "Good", "Fair", "Poor"];
export const NUMERIC_FIELDS = ["purchase_price", "size_tons", "health_score", "remaining_useful_life_months"];
export const BOOLEAN_FIELDS = ["gas_pack", "separate_air_handler"];

export function normalizeCondition(value: string): string {
  const normalized = value.toLowerCase().trim();
  switch (normalized) {
    case "excellent":
    case "new":
      return "New";
    case "good":
      return "Good";
    case "fair":
      return "Fair";
    case "poor":
      return "Poor";
    default:
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }
}
